import React from 'react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { IWorkspace } from '../../services/api'

interface WorkspaceItemProps {
  workspace: IWorkspace
  isActive?: boolean
  showSlug?: boolean
  showCheckmark?: boolean
  onClick: () => void
}

export const WorkspaceItem: React.FC<WorkspaceItemProps> = ({
  workspace,
  isActive = false,
  showSlug = true,
  showCheckmark = true,
  onClick,
}) => {
  const name = workspace.name || 'Moja przestrzeń'
  const initial = name[0].toUpperCase()

  return (
    <button
      onClick={onClick}
      className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
        isActive
          ? 'bg-gray-100 text-gray-900'
          : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <div className="flex items-center gap-x-3 min-w-0 flex-1">
        <div
          className={`h-10 w-10 flex-shrink-0 rounded-lg flex items-center justify-center text-white text-sm font-bold ${
            isActive ? 'ring-2 ring-offset-1' : ''
          }`}
          style={{
            backgroundColor: workspace.color || '#6366f1',
            ...(isActive && {
              '--tw-ring-color': workspace.color || '#6366f1',
            } as React.CSSProperties),
          }}
        >
          {initial}
        </div>
        <div className="text-left min-w-0 overflow-hidden">
          <span className="block truncate">{name}</span>
          {showSlug && (
            <span className="block text-xs text-gray-400 font-normal truncate">
              /{workspace.slug || workspace.id}
            </span>
          )}
        </div>
      </div>
      {showCheckmark && isActive && (
        <CheckIcon className="h-5 w-5 flex-shrink-0 text-gray-600 ml-2" />
      )}
    </button>
  )
}
